var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.59,
    height: 19.59,
    viewBox: "0 0 19.59 19.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M11.543,2.744a9.857,9.857,0,0,0,9.795-9.795,9.853,9.853,0,0,0-9.8-9.795A9.843,9.843,0,0,0,1.748-7.051,9.857,9.857,0,0,0,11.543,2.744Zm0-1.27A8.508,8.508,0,0,1,3.018-7.051a8.509,8.509,0,0,1,8.516-8.535,8.533,8.533,0,0,1,8.545,8.535A8.517,8.517,0,0,1,11.543,1.475ZM8.135-3.008a.579.579,0,0,0,.449-.2l2.949-2.959L14.5-3.2a.614.614,0,0,0,.449.2.611.611,0,0,0,.615-.605.6.6,0,0,0-.2-.449L12.4-7.031l2.979-2.979a.544.544,0,0,0,.186-.43.6.6,0,0,0-.615-.605.583.583,0,0,0-.43.2L11.533-7.881,8.574-10.85a.583.583,0,0,0-.439-.186.6.6,0,0,0-.615.6A.569.569,0,0,0,7.705-10l2.969,2.969L7.705-4.053a.569.569,0,0,0-.186.439A.611.611,0,0,0,8.135-3.008Z",
    transform: "translate(-1.748 16.846)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.58c7258d9cd0dd89a6ade0e6871cf8c0.svg";
export { ForwardRef as ReactComponent };